
import React, { useEffect, useRef, useState } from "react";
import "../Modals.css";
import ModalCreationMessage from "../ModalCreationMessage";
import DateTimePicker from "react-datetime-picker";
import MissionModelingService from "../../MissionModelingService";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const GroundStationAccessAnalysis = ({ props, parameterProps }) => {
  const params = useParams()
  const {
    mission_name,
    mission_id
  } = params;
  const [isModalVisible, setisModalVisible] = useState(true);
  const [isSuccessMsgVisible, setIsSuccessMsgVisible] = useState(false);
  const [message, setMessage] = useState("");

  const [duration, setDuration] = useState("Day");

  const [showItems, setShowItems] = useState({
    Satellites: true,
    Ground_Stations: true,
    Analysis_Timeframe: true,
  });

  const [eclipsePlanes, setEclipsePlanes] = useState<any[]>([]);
  const [selectedGs, setSelectedGs] = useState<any[]>([]);


  const [startTime, setStartTime] = useState(new Date());
  const [startTimeEpoch, setStartTimeEpoch] = useState(() => {
    const date = new Date();
    const utcEpoch = Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    ) / 1000;

    return utcEpoch;
  });

  const handleDateChange = (date) => {
    // Convert selected date to UTC
    const utcDate = new Date(Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    ));

    // Get UTC epoch value
    const utcEpoch = utcDate.getTime();

    // Set the UTC date in the state or perform any other action
    setStartTime(utcDate);
    setStartTimeEpoch(utcEpoch / 1000)

    console.log('UTC Date:', utcDate);
    console.log('UTC Epoch:', utcEpoch / 1000);
  };

  const showSuccessMessage = (msg) => {
    setMessage(msg);
    setIsSuccessMsgVisible(true);
    setTimeout(() => {
      setIsSuccessMsgVisible(false);
      props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
    }, 2000);
  };

  useEffect(() => {
    if (props.selectedComponent === 'Ground Station') {
      const data = {
        objectId: props?.selectedComponentId,
        groundstationName: props?.selectedComponentName,
      };
      let alreadyHas = selectedGs?.some(item => JSON.stringify(item) === JSON.stringify(data))

      if (!alreadyHas) {
        setSelectedGs([...selectedGs, data]);
      }
    } else if (props.selectedComponent === 'Satellite' || props.selectedComponent === 'Plane' || props.selectedComponent === 'Spaceobject') {
      const currentEclipseObject = {
        objectId: props?.selectedComponentId,
        name: props?.selectedComponentName,
        objectType: props?.selectedComponent,
      };

      let alreadyHas = eclipsePlanes?.some(item => JSON.stringify(item?.['objectId']) === JSON.stringify(currentEclipseObject?.['objectId']))
      if (!alreadyHas) {
        setEclipsePlanes([...eclipsePlanes, currentEclipseObject]);
      }
    }
  }, [props.selectedComponentId]);

  const postGSData = () => {

    let spaceObjects: any = []
    let gsObjects: any = []
    eclipsePlanes?.map((item: any) => {
      spaceObjects.push({ objectId: item?.['objectId'], objectType: item?.['objectType'] })
    })
    selectedGs?.map((item: any) => {
      gsObjects.push({ objectId: item?.['objectId'] })
    })
    let body = {
      spaceobjects: spaceObjects,
      groundStationsIds: gsObjects,
      startTime: startTimeEpoch,
      duration: duration,
    };

    MissionModelingService.postGSAnalysisData(body, mission_id)
      .then((res) => {
        toast.success("Ground Station Analysis Data Posted SuccessFully");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const removeEclipsePlanes = (item) => {
    const updatedPlanes = eclipsePlanes?.filter((eclipsePlanes) => eclipsePlanes?.['objectId'] !== item?.['objectId']);
    setEclipsePlanes(updatedPlanes);
  };
  const removeGroundStations = (item) => {
    const updatedPlanes = selectedGs?.filter((gs) => gs?.['objectId'] !== item?.['objectId']);
    setSelectedGs(updatedPlanes);
  };

  return (
    <>
      {isSuccessMsgVisible && <ModalCreationMessage props={props} message={message} />}
      {isModalVisible && (
        <>
          <div className={props.isSidebarVisible ? "mainModal sidebarOpenModal" : "mainModal"} id="coverageAnalysis">
            <div className="modalHeader">
              <div className="modalHeaderImg">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
                  <path
                    d="M16.5253 0.226194C17.3386 0.510384 18.1176 1.04032 18.6935 1.6973C19.8796 3.04804 19.8637 4.55174 19.4349 6.20422C19.4109 6.29666 19.3511 6.37576 19.2687 6.42412C19.1863 6.47248 19.0881 6.48613 18.9957 6.46208C18.9033 6.43803 18.8242 6.37824 18.7758 6.29586C18.7274 6.21349 18.7138 6.11528 18.7378 6.02284C19.1407 4.47066 19.1089 3.26201 18.1527 2.17206C17.6474 1.60035 17.0065 1.1649 16.2888 0.905743C15.5925 0.663345 14.923 0.651643 14.404 0.910758C14.3185 0.953321 14.2196 0.960192 14.1291 0.929861C14.0386 0.899529 13.9638 0.834479 13.9213 0.74902C13.8787 0.663562 13.8718 0.564695 13.9022 0.47417C13.9325 0.383646 13.9975 0.308878 14.083 0.266315C14.8327 -0.107312 15.7171 -0.0563247 16.5262 0.226194H16.5253ZM4.21329 19.2502C4.43497 19.2502 4.64757 19.1622 4.80432 19.0054C4.96108 18.8487 5.04914 18.636 5.04914 18.4144C5.04914 18.1927 4.96108 17.9801 4.80432 17.8233C4.64757 17.6666 4.43497 17.5785 4.21329 17.5785C3.99161 17.5785 3.77901 17.6666 3.62226 17.8233C3.4655 17.9801 3.37744 18.1927 3.37744 18.4144C3.37744 18.636 3.4655 18.8487 3.62226 19.0054C3.77901 19.1622 3.99161 19.2502 4.21329 19.2502Z"
                    fill={"#F0F0F0"}
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.1624 4.52803L16.1627 4.52877C16.2975 4.86355 16.2982 5.23738 16.1646 5.57264C16.031 5.9079 15.7734 6.17884 15.4453 6.32919C15.3486 6.37352 15.2879 6.47146 15.2911 6.57781L15.4758 12.6269C15.4783 12.7063 15.5162 12.7803 15.5792 12.8287L17.2258 14.0925L17.2264 14.0929C17.3403 14.1799 17.4173 14.3065 17.4422 14.4476C17.4672 14.5887 17.4382 14.7341 17.3609 14.8548C17.2837 14.9755 17.1639 15.0628 17.0254 15.0994C16.8868 15.1359 16.7395 15.119 16.6128 15.0521C16.5068 14.9961 16.3764 15.0183 16.295 15.1063C15.1949 16.295 13.845 17.1112 12.3237 17.3225L12.3234 17.3226C11.3387 17.4605 10.316 17.3402 9.27955 16.9384C9.1686 16.8953 9.04257 16.9317 8.97157 17.0272L8.30289 17.9266C8.21941 18.0389 8.23777 18.1967 8.34478 18.2868L12.3 21.6177L12.3001 21.6178C12.6368 21.9012 12.8834 22.2687 13.0203 22.6771C13.0565 22.785 13.1575 22.8576 13.2712 22.8576H13.3297C13.7201 22.8576 13.9839 23.136 13.9787 23.4241L13.9787 23.4289C13.9787 23.7217 13.7104 24.0002 13.3205 24.0002H0.955808C0.566895 24.0002 0.298462 23.7219 0.298462 23.4289C0.298462 23.1541 0.532543 22.8926 0.892999 22.8608C1.02958 22.8487 1.13431 22.7343 1.13431 22.5972V18.0501C1.13415 17.627 1.23286 17.2098 1.42257 16.8317C1.61229 16.4536 1.88775 16.1251 2.22698 15.8723C2.56621 15.6196 2.95981 15.4497 3.37639 15.376C3.79297 15.3024 4.22098 15.3272 4.62628 15.4484C4.73198 15.48 4.84619 15.4427 4.91287 15.3548L5.56985 14.4889C5.64214 14.3936 5.64153 14.2617 5.56835 14.1671C4.87294 13.268 4.47069 12.3035 4.34008 11.3024C4.1385 9.75672 4.59545 8.21387 5.47389 6.80951C5.54031 6.70332 5.52317 6.5651 5.43282 6.47834C5.32768 6.37738 5.26511 6.24004 5.25792 6.09445C5.25074 5.94886 5.29948 5.80603 5.39417 5.6952C5.48886 5.58438 5.62233 5.51394 5.76726 5.49832C5.91198 5.48272 6.05719 5.52295 6.17323 5.61079L6.17374 5.61117L7.67296 6.76128C7.73637 6.80993 7.81838 6.8273 7.89607 6.80855L13.258 5.51465C13.389 5.48306 13.4753 5.35818 13.4585 5.22455C13.416 4.88502 13.4986 4.54162 13.691 4.25862C13.8833 3.97562 14.1722 3.77241 14.5036 3.68703C14.835 3.60164 15.1861 3.63993 15.4912 3.79473C15.7967 3.94966 16.0357 4.21049 16.1624 4.52803ZM11.2854 9.53375L8.54511 7.42996C8.50847 7.40699 8.47718 7.37487 8.45495 7.33523C8.39698 7.23185 8.41483 7.10253 8.49864 7.01872L8.49947 7.01788C8.53959 6.97776 8.58976 6.953 8.64229 6.94411L13.4465 5.78509C13.5503 5.76005 13.659 5.79986 13.7221 5.88603C13.7815 5.96715 13.8494 6.04167 13.9247 6.10829C14.0285 6.20021 14.0438 6.35671 13.9596 6.46696L11.6569 9.48439C11.6142 9.54028 11.5511 9.5769 11.4814 9.58616C11.4117 9.59542 11.3412 9.57656 11.2854 9.53375ZM11.8448 9.8329C11.8448 9.91517 11.883 9.99276 11.9483 10.0428L14.7233 12.1718C14.8044 12.234 14.9141 12.2439 15.005 12.1973C15.096 12.1507 15.152 12.0559 15.1489 11.9537L14.9884 6.71292C14.9843 6.57817 14.8795 6.46807 14.7451 6.45727C14.6842 6.45238 14.6237 6.44347 14.564 6.4306C14.4638 6.409 14.3601 6.44723 14.2979 6.52871L11.899 9.67152C11.8638 9.71764 11.8448 9.77405 11.8448 9.83207V9.8329ZM6.74132 7.48655C6.68141 7.44057 6.6047 7.42239 6.53053 7.43657C6.45635 7.45076 6.39177 7.49597 6.35306 7.56081C5.63932 8.75613 5.3204 9.98491 5.47365 11.1543C5.63754 12.4117 6.35753 13.688 7.90038 14.8503C9.44394 16.0142 10.8895 16.3695 12.1651 16.1917C13.3203 16.0314 14.4033 15.4227 15.338 14.4551C15.3904 14.4009 15.4171 14.3269 15.4116 14.2517C15.406 14.1765 15.3686 14.1073 15.3088 14.0614L6.74132 7.48655ZM11.2744 22.8576C11.3855 22.8576 11.4848 22.7882 11.5229 22.6838C11.561 22.5793 11.5298 22.4622 11.4448 22.3906L4.86175 16.8474L4.86164 16.8473C4.63265 16.6543 4.35328 16.5307 4.05643 16.4911C3.75953 16.4515 3.4575 16.4976 3.18591 16.6239C2.91431 16.7502 2.68445 16.9515 2.52339 17.204C2.36234 17.4565 2.27679 17.7499 2.27682 18.0494V22.593C2.27682 22.7392 2.39528 22.8576 2.54141 22.8576H11.2744Z"
                    fill={"#F0F0F0"}
                  />
                  <path
                    d="M17.0583 2.36333C16.2375 1.56091 15.0824 1.37284 14.1019 1.78993C14.014 1.8274 13.9446 1.89825 13.909 1.98689C13.8733 2.07553 13.8743 2.17471 13.9118 2.26261C13.9492 2.35051 14.0201 2.41992 14.1087 2.45558C14.1974 2.49124 14.2966 2.49023 14.3845 2.45277C15.0991 2.14852 15.9441 2.28142 16.5552 2.87905C17.1695 3.47752 17.3684 4.38024 17.1269 5.17347C17.1132 5.21875 17.1085 5.26629 17.1131 5.31337C17.1178 5.36045 17.1317 5.40616 17.154 5.44787C17.1763 5.48959 17.2066 5.52651 17.2432 5.55651C17.2798 5.58652 17.3219 5.60902 17.3672 5.62274C17.4125 5.63646 17.46 5.64113 17.5071 5.63648C17.5542 5.63183 17.5999 5.61795 17.6416 5.59563C17.6833 5.57332 17.7202 5.54301 17.7502 5.50643C17.7802 5.46984 17.8027 5.42771 17.8164 5.38243C18.1307 4.34848 17.8766 3.16157 17.0583 2.36333Z"
                    fill={"#F0F0F0"}
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    strokeWidth="30px"
                    d="M0.850462 2.4447C0.678564 2.6925 0.615385 2.88655 0.615385 3.00019C0.615385 3.11383 0.678564 3.30788 0.850462 3.55568C1.01703 3.79485 1.264 4.05455 1.57662 4.29455C2.20308 4.77537 3.06174 5.15403 4 5.15403C4.93826 5.15403 5.79692 4.77537 6.42338 4.29455C6.736 4.05455 6.98297 3.79485 7.14954 3.55568C7.32144 3.30788 7.38462 3.11383 7.38462 3.00019C7.38462 2.88655 7.32144 2.6925 7.14954 2.4447C6.98297 2.20552 6.736 1.94583 6.42338 1.70583C5.79692 1.22501 4.93826 0.846342 4 0.846342C3.06174 0.846342 2.20308 1.22501 1.57662 1.70583C1.264 1.94583 1.01703 2.20552 0.850462 2.4447ZM1.20164 1.21762C1.91179 0.672803 2.89887 0.230957 4 0.230957C5.10113 0.230957 6.08821 0.672803 6.79795 1.21762C7.15364 1.49044 7.44738 1.79485 7.65497 2.09393C7.85682 2.3848 8 2.70357 8 3.00019C8 3.2968 7.85641 3.61557 7.65497 3.90644C7.44738 4.20552 7.15364 4.50952 6.79836 4.78275C6.08862 5.32757 5.10113 5.76942 4 5.76942C2.89887 5.76942 1.91179 5.32757 1.20205 4.78275C0.846359 4.50993 0.552615 4.20552 0.345026 3.90644C0.14359 3.61557 0 3.2968 0 3.00019C0 2.70357 0.14359 2.3848 0.345026 2.09393C0.552615 1.79485 0.846359 1.49085 1.20164 1.21762Z"
                    fill={"#F0F0F0"}
                    className="positionSvgGroundStn"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    strokeWidth="30px"
                    d="M2.46094 2.99989C2.46094 2.59186 2.62302 2.20055 2.91154 1.91203C3.20006 1.62351 3.59137 1.46143 3.9994 1.46143C4.40742 1.46143 4.79874 1.62351 5.08726 1.91203C5.37577 2.20055 5.53786 2.59186 5.53786 2.99989C5.53786 3.40791 5.37577 3.79923 5.08726 4.08774C4.79874 4.37626 4.40742 4.53835 3.9994 4.53835C3.59137 4.53835 3.20006 4.37626 2.91154 4.08774C2.62302 3.79923 2.46094 3.40791 2.46094 2.99989ZM3.9994 2.07681C3.75458 2.07681 3.5198 2.17406 3.34669 2.34717C3.17357 2.52028 3.07632 2.75507 3.07632 2.99989C3.07632 3.2447 3.17357 3.47949 3.34669 3.6526C3.5198 3.82571 3.75458 3.92296 3.9994 3.92296C4.24421 3.92296 4.479 3.82571 4.65211 3.6526C4.82522 3.47949 4.92248 3.2447 4.92248 2.99989C4.92248 2.75507 4.82522 2.52028 4.65211 2.34717C4.479 2.17406 4.24421 2.07681 3.9994 2.07681Z"
                    fill={"#F0F0F0"}
                    className="positionSvgGroundStn"
                  />
                </svg>
              </div>
              <span>Ground Station Access</span>
              <button
                className="modalCloseBtn"
                onClick={() => {
                  setisModalVisible(false);
                  props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
                }}
              >
                <img src={require("../../ImageSvgs/CloseButtonWhite.svg").default} />
              </button>
              <button
                className="modalCloseBtn modalMinimizeBtn"
                onClick={() => {
                  setisModalVisible(false);
                  props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
                }}
              >
                <img src={require("../../ImageSvgs/MinimizeButtonWhite.svg").default} />
              </button>
            </div>

            <div className="modalScrollableSection">
              <div className="modalCheckboxDiv">
                <button
                  className="modalDropDownIconBtn"
                  onClick={() =>
                    setShowItems({
                      ...showItems,
                      Satellites: !showItems.Satellites,
                    })
                  }
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d={showItems.Satellites ? "M6.01108 8.97725L11.9879 15.0003L18.011 9.02344" : "M8.9775 17.9887L15.0005 12.0118L9.02368 5.98877"}
                      stroke="#33E18F"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <div className="modalCheckboxText modalGreenSubHeader modalCheckboxTextRight">Space Objects</div>
              </div>

              {showItems.Satellites && (
                <div className="modalrefOrbitDiv">
                  {eclipsePlanes?.length > 0 && eclipsePlanes?.map((item) => {
                    return (
                      <div key={item?.['objectId']} className="modalrefOrbitsBtn orbitsBtnSpacer">
                        <span>{item?.["name"]}</span>
                        <button
                          className="modalrefOrbitsCloseBtn"
                          onClick={() => {
                            removeEclipsePlanes(item);
                          }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 12 12" fill="none">
                            <path d="M1.2002 10.8L10.8002 1.19995" stroke="#0A0A0A" strokeLinecap="round" />
                            <path d="M1.20029 1.19995L10.8003 10.8" stroke="#0A0A0A" strokeLinecap="round" />
                          </svg>
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="modalCheckboxDiv">
                <button
                  className="modalDropDownIconBtn"
                  onClick={() =>
                    setShowItems({
                      ...showItems,
                      Ground_Stations: !showItems.Ground_Stations,
                    })
                  }
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d={showItems.Ground_Stations ? "M6.01108 8.97725L11.9879 15.0003L18.011 9.02344" : "M8.9775 17.9887L15.0005 12.0118L9.02368 5.98877"}
                      stroke="#33E18F"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <div className="modalCheckboxText modalGreenSubHeader modalCheckboxTextRight">Ground Stations</div>
              </div>

              {showItems.Ground_Stations && (
                <div className="modalrefOrbitDiv">
                  {selectedGs?.length > 0 && selectedGs?.map(gs => {
                    return (
                      <div className="modalrefOrbitsSpacer">
                        <div key={gs?.['objectId']}
                          className="modalrefOrbitsBtn modalGroundStationBlueBtn"
                        >
                          <span>{gs?.['groundstationName']}</span>
                          <button
                            className="modalrefOrbitsCloseBtn modalGroundStationBlueBtn"
                            onClick={() =>
                              removeGroundStations(gs)
                            }
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 12 12" fill="none">
                              <path d="M1.2002 10.8L10.8002 1.19995" stroke="#0A0A0A" strokeLinecap="round" />
                              <path d="M1.20029 1.19995L10.8003 10.8" stroke="#0A0A0A" strokeLinecap="round" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    )
                  })
                  }
                </div>
              )}

              <div className="modalCheckboxDiv">
                <button
                  className="modalDropDownIconBtn"
                  onClick={() => {
                    setShowItems({
                      ...showItems,
                      Analysis_Timeframe: !showItems.Analysis_Timeframe,
                    });
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d={showItems.Analysis_Timeframe ? "M6.01108 8.97725L11.9879 15.0003L18.011 9.02344" : "M8.9775 17.9887L15.0005 12.0118L9.02368 5.98877"}
                      stroke="#33E18F"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <div className="modalCheckboxText modalGreenSubHeader modalCheckboxTextRight">Analysis timeframe</div>
              </div>

              {showItems.Analysis_Timeframe && (
                <>
                  <div className="modalAnalysisDiv">
                    <div className="modalAnalysisText">Start Time</div>

                    <DateTimePicker
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yy"
                      hourPlaceholder="hh"  // Use 'hh' for 12-hour format or 'HH' for 24-hour format
                      minutePlaceholder="mm"
                      secondPlaceholder="ss"
                      format={"y-MM-dd HH:mm:ss"}  // Use 'HH' for 24-hour format
                      onChange={handleDateChange}
                      value={startTime}
                      disableClock={true}
                      maxDetail={"second"}
                      locale="en-GB"
                    />
                  </div>

                  <div className="modalAnalysisDiv blockDisplay">
                    <div className="modalAnalysisText blockDisplay">Duration</div>

                    <select className="modalSelect blockDisplay eclipseAnalysis">
                      <option className="modalSelectOption" value="Cuboid" disabled>
                        Hours
                      </option>
                      <option className="modalSelectOption" value="Cuboid" disabled>
                        Minutes
                      </option>
                      <option className="modalSelectOption" selected value="Cube" >
                        Day
                      </option>
                    </select>
                    <input
                      className="modalAnalysisInput blockDisplay"
                      type="number"
                      value={duration}
                      onKeyDown={(e) => {
                        if (e.keyCode === 13 || e.keyCode === 69) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(event) => {
                        setDuration(event.target.value);
                      }}
                      placeholder={"#"}
                      style={{ width: "25px", marginRight: "8px" }}
                    />
                  </div>
                </>
              )}
            </div>

            <div className="modalFooter">
              <button
                className="modalFooterclose"
                onClick={() => {
                  setisModalVisible(false);
                  props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
                }}
              >
                Close
              </button>
              <button
                className="modalFooterapply"
                onClick={() => {
                  setisModalVisible(false);
                  showSuccessMessage(
                    "Ground Station Access Analysis successful"
                  );
                  postGSData()
                  props.setSideReportBarProps({ isSideReportBarVisible: true });
                  props.setShowSidebarReportComponent("Ground Station");
                }}
              >
                Analyse
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default GroundStationAccessAnalysis;
